import { Controller } from "@hotwired/stimulus"

// Toggles check-all / uncheck-all for the Select Teams to Import table
export default class extends Controller {
  static targets = ["checkbox"]

  checkAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  uncheckAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }
}
